import { defineMessage, defineMessages, MessageDescriptor } from 'react-intl';

import { CountryCode, TCountryCodes } from '@/shared/models/country-code';
import { ValuesOf } from '@/shared/utils/types';

export const ENGINES = {
  PETROL: 'petrol',
  DIESEL: 'diesel',
  ELECTRIC: 'electric',
  HYBRID: 'hybrid',
} as const;

export type EngineType = ValuesOf<typeof ENGINES>;

export const ENGINE_MESSAGES = defineMessages({
  [ENGINES.PETROL]: {
    defaultMessage: 'Petrol',
    id: 'global_vehicle_info_engine_petrol',
    description: 'Petrol engine option',
  },
  [ENGINES.DIESEL]: {
    defaultMessage: 'Diesel',
    id: 'global_vehicle_info_engine_diesel',
    description: 'Diesel engine option',
  },
  [ENGINES.HYBRID]: {
    defaultMessage: 'Hybrid',
    id: 'global_vehicle_info_engine_hybrid',
    description: 'Hybrid engine option',
  },
  [ENGINES.ELECTRIC]: {
    defaultMessage: 'Electric',
    id: 'global_vehicle_info_engine_electric',
    description: 'Electric engine option',
  },
});

const GAS_MESSAGE = defineMessage({
  defaultMessage: 'Gas',
  id: 'global_vehicle_info_engine_gas',
  description: 'Gas engine option (US)',
});

export const REGION_OVERRIDES: Partial<
  Record<TCountryCodes, Partial<Record<EngineType, MessageDescriptor>>>
> = {
  [CountryCode.UnitedStates]: {
    [ENGINES.PETROL]: GAS_MESSAGE,
  },
};
